<template>
    <div class="Transfer Card Card--top">
        <div class="Card-header">
            <button class="Card-headerControl Button Transfer-close" @click="$emit('close', true)">&times;</button>
            <h2 class="Card-title">{{ title }}</h2>
        </div>
        <tl-form
            class="Card-body"
            :schema="schema"
            :url="url">
        </tl-form>
    </div>
</template>

<script>
    import './_FormWrapper.scss';

    export default {
        props: {
          title: String,
          schema: Array,
          url: String,
        },
        computed: {},
        methods: {
          close() {
              this.$emit('close', true);
          },
          submit() {
              this.$refs.form.submit();
          },
          success(response) {
              this.$emit('success', response);
          },
          error(error) {
              this.$emit('error', error);
          }
        },
        data: function () {
            return {}
        }
    }
</script>
